import { render, staticRenderFns } from "./AGCEditGroupInput.vue?vue&type=template&id=4b587143&scoped=true&"
import script from "./AGCEditGroupInput.vue?vue&type=script&lang=js&"
export * from "./AGCEditGroupInput.vue?vue&type=script&lang=js&"
import style0 from "./AGCEditGroupInput.vue?vue&type=style&index=0&id=4b587143&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b587143",
  null
  
)

export default component.exports